module.exports = __webpack_public_path__ + "assets/img/login_icon1.deb504e0.png";